import * as AceSdk from '@ace-auth/sdk-browser';

import { storageKeys } from '../helpers';

const getLocale = lang => (!lang ? 'zh-CN' : lang === 'en' ? 'en-US' : lang);
let AceService;

const initAceService = () => {
  if (!AceService) {
    AceService = new AceSdk.CreateClient({
      aceEndpoint: process.env.REACT_APP_ACE_ENDPOINT || '',
      ownAceEndpoint: process.env.REACT_APP_ACE_SSO_ENDPOINT || '',
      clientId: process.env.REACT_APP_CLIENT_ID || '',
      signInRedirectUri: process.env.REACT_APP_MS_PLATFORM_ENDPOINT || '',
      signUpRedirectUri: process.env.REACT_APP_MS_PLATFORM_ENDPOINT || '',
      storageKey: storageKeys.AUTH_TOKENS,
      autorefresh: true,
    });
  }

  return AceService;
};

export const getTokens = async () => {
  const aceService = initAceService();

  try {
    return await aceService.getTokens();
  } catch (error) {
    return null;
  }
};

export const signIn = async lang => {
  const aceService = initAceService();

  aceService.setLocale(getLocale(lang));

  const authTokens = await aceService.signIn();

  if (authTokens) {
    window.location = process.env.REACT_APP_MS_PLATFORM_ENDPOINT;
  }
};

export const signUp = async lang => {
  const aceService = initAceService();

  aceService.setLocale(getLocale(lang));
  await aceService.signUp();
};



// WEBPACK FOOTER //
// /app/apps/ms/src/services/AceService.js